<ng-template #modal>
  <div class="modal-header">
    <h4 i18n class="modal-title">{{ getModalTitle() }}</h4>

    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="hide()"></my-global-icon>
  </div>

  <div class="modal-body">
    <div class="description" i18n>
      A banned user will no longer be able to login.
    </div>

    <form novalidate [formGroup]="form" (ngSubmit)="banUser()">
      <div class="form-group">
        <textarea
          i18n-placeholder placeholder="Reason..." formControlName="reason"
          class="form-control" [ngClass]="{ 'input-error': formErrors['reason'] }"
        ></textarea>
        <div *ngIf="formErrors.reason" class="form-error">
          {{ formErrors.reason }}
        </div>
      </div>

      <div class="form-group">
        <my-peertube-checkbox
          inputName="banMute" formControlName="mute"
          i18n-labelText labelText="Mute to also hide videos/comments"
        >
        </my-peertube-checkbox>
      </div>

      <div class="form-group inputs">
        <input
          type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
          (click)="hide()" (key.enter)="hide()"
        >

        <input type="submit" i18n-value [value]="getModalTitle()" class="peertube-button orange-button" [disabled]="!form.valid" />
      </div>
    </form>
  </div>

</ng-template>
